<template>
  <div class="row main-content">
    <div class="col-12">
      <h1>404</h1>
      <h2>{{ 'page_not_found_message' | i18n }}</h2>
      <router-link
        to="/"
        class="btn btn-outline-primary"
        :title="'btn_back_to_home_page' | i18n"
        :aria-label="'btn_back_to_home_page' | i18n"
      >
        {{ 'btn_back_to_home_page' | i18n }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
};
</script>

<style scoped>
    html {
        height: 100%;
    }

    body > div {
        height: 100%;
    }

    .btn {
        margin-top: 10px;
    }

    h1 {
        font-size: 2.8rem !important;
        margin-bottom: 20px;
        color: #6C737D;
    }

    h2 {
        font-size: 1.5rem !important;
    }

  .main-content {
    margin-top: 35px;
  }
</style>
